// HIER KOMEN ALLE NIEUWE PACKAGES/OUDE BOWER PACKAGES
var $ = require('jquery');

import Foundation from 'foundation-sites';
import Slick from 'slick-carousel';

// Onderstaande ter illustratie voor het toevoegen van een module die leunt op jquery
Foundation.addToJquery($);